import { JobReady } from "../../../../models";
import { DataAPI_Base } from "../base";

export class JobsReadyAPI extends DataAPI_Base<JobReady> {
	constructor() {
		super("jobsready");
	}
}
